export const courseLevelAnalyticsTabs = (
  organizationId: string,
  courseId: string,
) => [
  {
    title: 'Overview',
    link: `/manage/${organizationId}/analytics/course/${courseId}/overview`,
  },
  {
    title: 'Learners',
    link: `/manage/${organizationId}/analytics/course/${courseId}/learners`,
  },
  {
    title: 'Comments',
    link: `/manage/${organizationId}/analytics/course/${courseId}/comments`,
  },
  {
    title: 'Likes',
    link: `/manage/${organizationId}/analytics/course/${courseId}/likes`,
  },
];
